import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import PageHead from "@/components/PageHead";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { useI18n } from "@/i18n/I18nProvider";

const GoogleMapsLoader = dynamic(() => import("@/components/maps/MapLoader"), {
  ssr: false,
});

const MapBox = dynamic(() => import("@/components/maps/MapBox"), {
  ssr: false,
  loading: () => (
    <Box className="horizontal-safe-padding" sx={{ py: 3 }}>
      <Skeleton
        variant="rectangular"
        height={560}
        sx={{ borderRadius: "16px" }}
      />
    </Box>
  ),
});

export default function Branches() {
  const { t, locale } = useI18n();

  const [shouldLoadMap, setShouldLoadMap] = useState(false);

  useEffect(() => {
    if (shouldLoadMap) return;
    if (typeof window === "undefined") return;

    const id =
      "requestIdleCallback" in window
        ? window.requestIdleCallback(() => setShouldLoadMap(true), {
            timeout: 2500,
          })
        : window.setTimeout(() => setShouldLoadMap(true), 1500);

    return () => {
      if ("cancelIdleCallback" in window) window.cancelIdleCallback(id);
      else clearTimeout(id);
    };
  }, [shouldLoadMap]);

  return (
    <>
      <PageHead
        title={t.pages_main_tags.ourBranches.title}
        description={t.pages_main_tags.ourBranches.meta_desc}
      />


      {/* CLS: احجز مساحة ثابتة للخريطة حتى قبل ما تحمل */}
      <Box
        sx={{ py: 3, minHeight: 560 }}
      >
        {shouldLoadMap ? (
          <GoogleMapsLoader locale={locale}>
            <MapBox locale={locale} />
          </GoogleMapsLoader>
        ) : (
          <Skeleton
            variant="rectangular"
            height={560}
            sx={{ borderRadius: "16px" }}
          />
        )}
      </Box>
    </>
  );
}
